/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Form, hasDefinedValues, UseFormHook } from '@jalik/react-form'
import { PropsWithChildren, useEffect } from 'react'
import logger from '../../lib/logger'
import { useNavigate } from 'react-router'
import { notifications } from '@mantine/notifications'
import { FormattedMessage } from 'react-intl'
import { Text } from '@mantine/core'
import FormErrors from './FormErrors'

const NOTIF_ID = 'FormSubmitError'

export type SmartFormProps<V, E, R> = PropsWithChildren & {
  context: UseFormHook<V, E, R>,
  redirectUrl?: string
}

function SmartForm<V = any, E = Error, R = any> (props: SmartFormProps<V, E, R>) {
  const {
    children,
    context,
    redirectUrl
  } = props

  const { submitError, errors } = context
  const navigate = useNavigate()

  useEffect(() => {
    if (hasDefinedValues(errors)) {
      logger.error('Form is not valid', { errors })
    }
  }, [errors])

  useEffect(() => {
    if (context.submitted) {
      notifications.show({
        id: NOTIF_ID,
        color: 'green',
        message: <FormattedMessage
          id="changes_saved"
          defaultMessage="Modifications enregistrées."
        />
      })
    } else if (submitError != null) {
      notifications.show({
        id: NOTIF_ID,
        color: 'red',
        title: <FormattedMessage
          id="form_submit_failed"
          defaultMessage="L'envoi du formulaire a échoué."
        />,
        message: <Text c="red">
          {submitError.message}
        </Text>
      })
    } else {
      notifications.hide(NOTIF_ID)
    }
  }, [context.submitted, submitError])

  useEffect(() => {
    if (context.submitted && redirectUrl) {
      navigate(redirectUrl)
    }
  }, [context.submitted, navigate, redirectUrl])

  return (
    <Form context={context}>
      <FormErrors />

      {children}
    </Form>
  )
}

export default SmartForm
